'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/to-string-tag-support.js
// module id = 293
// module chunks = 0